import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, ToastController } from 'ionic-angular';
import { GN } from '../../../gn';
import { DIC } from '../../dic';
import * as moment from 'moment';

/**
 * Generated class for the AddreportPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-addreport',
  templateUrl: 'addreport.html',
})
export class AddreportPage {
  _rname: string = '';
  _rid = -1
  _ch = [];

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public modalCtrl: ModalController, public toastCtrl: ToastController) {
    if (this.navParams.get('repdata') == null) {
      for (var i = 0; i < 222; i++) {
        this._ch[i] = false;
      }
    } else {
      this._ch[0] = this.navParams.get('repdata').pastdistance == "1" ? true : false;
      this._ch[1] = this.navParams.get('repdata').engineon == "1" ? true : false;
      this._ch[2] = this.navParams.get('repdata').drive == "1" ? true : false;
      this._ch[3] = this.navParams.get('repdata').stay == "1" ? true : false;
      this._ch[4] = this.navParams.get('repdata').engineoff == "1" ? true : false;
      this._ch[5] = this.navParams.get('repdata').parked == "1" ? true : false;
      this._ch[6] = this.navParams.get('repdata').maxspeed == "1" ? true : false;
      this._ch[7] = this.navParams.get('repdata').over60 == "1" ? true : false;
      this._ch[8] = this.navParams.get('repdata').over80 == "1" ? true : false;
      this._ch[9] = this.navParams.get('repdata').over100 == "1" ? true : false;
      this._ch[10] = this.navParams.get('repdata').over120 == "1" ? true : false;

      this._ch[11] = this.navParams.get('repdata').notours == "1" ? true : false;
      this._ch[12] = this.navParams.get('repdata').distintours == "1" ? true : false;
      this._ch[13] = this.navParams.get('repdata').disttaxi == "1" ? true : false;
      this._ch[14] = this.navParams.get('repdata').distwithouttaxi == "1" ? true : false;
      this._ch[15] = this.navParams.get('repdata').distouttours == "1" ? true : false;
      this._ch[16] = this.navParams.get('repdata').tourtime == "1" ? true : false;
      this._ch[17] = this.navParams.get('repdata').idletime == "1" ? true : false;
      this._ch[18] = this.navParams.get('repdata').profit == "1" ? true : false;
      this._ch[19] = this.navParams.get('repdata').loss == "1" ? true : false;
      this._ch[20] = this.navParams.get('repdata').eff == "1" ? true : false;

      this._ch[21] = this.navParams.get('repdata').driver == "1" ? true : false;

      this._ch[22] = this.navParams.get('repdata').firstignon == "1" ? true : false;
      this._ch[23] = this.navParams.get('repdata').lastignoff == "1" ? true : false;

      this._ch[24] = this.navParams.get('repdata').spentfuel == "1" ? true : false;
      this._ch[25] = this.navParams.get('repdata').fuelconsumption == "1" ? true : false;

      this._ch[26] = this.navParams.get('repdata').spentfueldrive == "1" ? true : false;
      this._ch[27] = this.navParams.get('repdata').fuelconsumptiondrive == "1" ? true : false;
      this._ch[28] = this.navParams.get('repdata').spentfuelstay == "1" ? true : false;
      this._ch[29] = this.navParams.get('repdata').fuelconsumptionstay == "1" ? true : false;

      this._ch[30] = this.navParams.get('repdata').maxcbrpm == "1" ? true : false;
      this._ch[31] = this.navParams.get('repdata').avgcbrpm == "1" ? true : false;
      this._ch[32] = this.navParams.get('repdata').maxcbtemp == "1" ? true : false;
      this._ch[33] = this.navParams.get('repdata').avgcbtemp == "1" ? true : false;

      this._ch[34] = this.navParams.get('repdata').startodometer == "1" ? true : false;
      this._ch[35] = this.navParams.get('repdata').endodometer == "1" ? true : false;

      this._ch[36] = this.navParams.get('repdata').totalcosts == "1" ? true : false;
      this._ch[37] = this.navParams.get('repdata').totalservicecosts == "1" ? true : false;
      this._ch[38] = this.navParams.get('repdata').totalfuelcosts == "1" ? true : false;
      this._ch[39] = this.navParams.get('repdata').totalothcosts == "1" ? true : false;

      this._ch[40] = this.navParams.get('repdata').totallitersfuelcosts == "1" ? true : false;

      this._ch[41] = this.navParams.get('repdata').visitedpoi == "1" ? true : false;

      this._ch[42] = this.navParams.get('repdata').ewt == "1" ? true : false;

      this._ch[43] = this.navParams.get('repdata').addedcbfuel == "1" ? true : false;

      this._rid = this.navParams.get('repdata').id
    }

    //alert(this.gn.decrypt(this.navParams.get('repid')))
    this._rname = ''
    if (this.gn.decrypt(this.navParams.get('repid')) + '' != '-1')
      this._rname = this.navParams.get('repdata').name
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddreportPage');
  }

  addNewReport() {
    if (this._rname + '' == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["enterrepname"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    //this._rname
    //alert(this._ch[0] + ' ' + this._ch[2])
    var _that = this
    var _dat = {
      uid: this.gn.crypt(this.gn.user.UserId),
      repname: this.gn.crypt(this._rname),
      ch: this.gn.crypt(this._ch),
      rid: this.gn.crypt(this._rid),
      clienttypeid: this.gn.crypt(this.gn.clientsettings.clienttypeid)
    }

    //this.gn.disableBtn();
    this.gn.tfBtn = true;
    var _that = this
    this.gn._Post('/api/gn/reports/insertrepgen', _dat, function (_data) {
      var _repid = _data[0].id
      var _repname = _data[0].repname
      _that.navCtrl.pop()
      _that.gn.tfBtn = false;
      var _cb = _that.navParams.get('cb');
      _cb(_repid, _repname, _that._rid);
    })
  }

  Round(_txt) {
    return parseInt(_txt + '')
  }

  RoundFloat(_txt) {
    return parseFloat(parseFloat(_txt + '').toFixed(1));
  }

  RoundFloat1(_txt) {
    return parseFloat(_txt + '').toFixed(0);
  }

  RoundFloatCeil(_txt) {
    return Math.ceil(parseFloat(_txt + ''));
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/addreport/addreport.ts